import { FolderOpenOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Form, Input, Spin, Upload, message } from "antd";
import { useRequest } from "ahooks";
import { UploadImage } from "../Service/MediaMakerService";
import { useEditorContext } from "../EditorContext";
import { useState } from "react";

const ImageUpploadField: React.FC = ({ name, label, rules }) => {
  const form = Form.useFormInstance();
  const localFileKey = localStorage.getItem("fileKey");
  const firstFileKey = localFileKey
    ? localFileKey
    : process.env.REACT_APP_FILE_KEY;
  const { shareRefs } = useEditorContext();
  const [uploadLoading, setUploadLoading] = useState(false);
  const { run: runUploadImage } = useRequest(UploadImage, {
    manual: true,
    onSuccess: (data) => {
      handleInsertPath(data.file_link);
    },
    onError: (err) => {
      message.error(err.message);
      setUploadLoading(false);
    },
  });

  const customRequest = (option: any) => {
    setUploadLoading(true);
    const file = option.file as File;
    let formData = new FormData();
    formData.append("file", file);
    formData.append("file_key", firstFileKey);
    runUploadImage(formData);
  };

  const handleInsertPath = (link: string) => {
    form.setFieldValue(name, link);
    form.submit();
    setUploadLoading(false);
  };
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={{ width: "100%" }}>
        <Form.Item name={name} label={label} rules={rules}>
          {!!!uploadLoading?<Input
            style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
          />: <div style={{alignItems: 'center'}}><Spin /></div>}
        </Form.Item>
      </div>
      <div style={{ height: 64, marginTop: label ? 13: -10, display: "flex", alignItems: "center" }}>
        <Upload
          accept=".png, .jpeg, .jpg, .gif"
          onChange={({ file }) => {
            if (file.status === "done") {
              handleInsertPath(file.response.url);
            }
          }}
          customRequest={customRequest}
          showUploadList={false}
        >
          <Button
            type="primary"
            icon={<UploadOutlined />}
            style={{ borderRadius: 0 }}
          />
        </Upload>
        <Button
          style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={() => {
            shareRefs.triggerFileManger(true);
            shareRefs.handleInsertPath = handleInsertPath;
          }}
        />
      </div>
    </div>
  );
};

export default ImageUpploadField;
